var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#858585;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50.526)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.526)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M64.07.462a.783.783,0,0,0-.838.125L62.025,1.633a.088.088,0,0,1-.115,0L60.268.2a.8.8,0,0,0-1.043,0l-1.64,1.436a.088.088,0,0,1-.116,0L55.828.2a.8.8,0,0,0-1.043,0L53.142,1.632a.088.088,0,0,1-.116,0L51.819.587a.788.788,0,0,0-1.1.063.751.751,0,0,0-.2.511V16.839a.769.769,0,0,0,.772.766.788.788,0,0,0,.522-.192l1.207-1.046a.088.088,0,0,1,.115,0L54.785,17.8a.8.8,0,0,0,1.043,0l1.641-1.436a.088.088,0,0,1,.116,0L59.225,17.8a.8.8,0,0,0,1.043,0l1.642-1.437a.088.088,0,0,1,.116,0l1.208,1.046a.788.788,0,0,0,1.1-.063.751.751,0,0,0,.2-.51V1.161A.753.753,0,0,0,64.07.462ZM53.405,6.107h4.33a.34.34,0,1,1,0,.681h-4.33a.34.34,0,1,1,0-.681Zm8.243,5.786H53.405a.34.34,0,1,1,0-.681h8.243a.34.34,0,1,1,0,.681Zm0-2.553H53.405a.34.34,0,1,1,0-.681h8.243a.34.34,0,1,1,0,.681Z",
    transform: "translate(-50.526 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.97a81528.svg";
export { ForwardRef as ReactComponent };